// Ajaxy bits for the register modal.
if (!window.daz) {
    window.daz = {};
}

(function () {
    var MODAL_ID = 'cart-register-modal';
    var RECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js';
    var TRIGGER_SELECTOR = '.js-open-register-modal, .register-at-checkout';
    var recaptchaRequested = false;

    function getModal() {
        return document.getElementById(MODAL_ID);
    }

    function loadRecaptcha() {
        if (recaptchaRequested || window.grecaptcha) {
            return;
        }

        recaptchaRequested = true;

        var script = document.createElement('script');
        script.src = RECAPTCHA_SRC;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    function openModal() {
        var modal = getModal();
        if (!modal) {
            return;
        }

        loadRecaptcha();
        modal.classList.add('cart-download-modal--open');
        modal.setAttribute('aria-hidden', 'false');

        var firstInput = modal.querySelector('.cart-download-modal__field input');
        if (firstInput) {
            window.setTimeout(function () {
                firstInput.focus();
            }, 0);
        }
    }

    function closeModal() {
        var modal = getModal();
        if (!modal) {
            return;
        }

        modal.classList.remove('cart-download-modal--open');
        modal.setAttribute('aria-hidden', 'true');
    }

    function initTriggers() {
        document.addEventListener('click', function (e) {
            var trigger = e.target.closest(TRIGGER_SELECTOR);
            if (!trigger) {
                return;
            }

            e.preventDefault();
            openModal();
        });
    }

    function initCloseHandlers() {
        var modal = getModal();
        if (!modal) {
            return;
        }

        var closeBtn = modal.querySelector('.cart-download-modal__close');
        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.preventDefault();
                closeModal();
            });
        }

        modal.addEventListener('click', function (e) {
            if (e.target === modal) {
                closeModal();
            }
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && modal.classList.contains('cart-download-modal--open')) {
                closeModal();
            }
        });
    }

    daz.registerModal = {
        open: openModal,
        close: closeModal,
        init: function () {
            if (!getModal()) {
                return;
            }

            initTriggers();
            initCloseHandlers();
        }
    };

    $(document).ready(function () {
        daz.registerModal.init();
    });
})();
